export default __webpack_public_path__ + "static/media/amazon.a6eb5586.png";